import { useGetLeaseCompLayoutsQuery } from "@/services/user";
import { EmeraldCheckbox } from "@emerald-react/checkbox";
import useSurveyState from "@hooks/useSurveyState";
import { useUpdateSurveyFlagsMutation } from "@services/survey-core";
import React, { useState } from "react";
import EditLeaseColumns from "../comparisonSection/EditLeaseColumns";

const LeaseComparisonSection = () => {
  const { survey } = useSurveyState();
  const [updateSurveyFlags] = useUpdateSurveyFlagsMutation();
  const [isEditColumnsOpen, setIsEditColumnsOpen] = useState(false);
  const teamId = survey?.teamId ?? "";
  const { data: leaseCompLayouts } = useGetLeaseCompLayoutsQuery({ teamId });

  const toggleOpenEditColumns = (e?: React.MouseEvent) => {
    e?.preventDefault();
    setIsEditColumnsOpen(!isEditColumnsOpen);
  };

  const handleShowPropertyPhotoChange = (value: boolean) => {
    updateSurveyFlags({ id: survey?.id, showPropertyPhoto: value });
  };

  return survey ? (
    <section className="flex flex-col gap-y-2 w-full text-sm">
      <div>
        You can change the order or visibility of lease comp data by{" "}
        <a
          href="#"
          className="text-primary underline"
          onClick={toggleOpenEditColumns}
        >
          editing the columns
        </a>{" "}
        for this survey.
      </div>

      <EmeraldCheckbox
        label="Show Property Photo"
        checked={survey.showPropertyPhoto ?? true}
        onChange={handleShowPropertyPhotoChange}
      />

      <EditLeaseColumns
        isOpen={isEditColumnsOpen}
        onClose={toggleOpenEditColumns}
        layouts={leaseCompLayouts}
      />
    </section>
  ) : null;
};

export default LeaseComparisonSection;
